import { render, staticRenderFns } from "./shenzhenHMBModel.vue?vue&type=template&id=0920ddf7&scoped=true&"
import script from "./shenzhenHMBModel.vue?vue&type=script&lang=js&"
export * from "./shenzhenHMBModel.vue?vue&type=script&lang=js&"
import style0 from "./shenzhenHMBModel.vue?vue&type=style&index=0&id=0920ddf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920ddf7",
  null
  
)

export default component.exports